import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetAmenityByIdQuery } from "../../../services/bClientApi"
import AmenityEntry from "../../../Components/Amenity/AmenityEntry/AmenityEntry"
import DataLogList from "../../../Components/DataLogs/DataLogList"

export default function AmenityPage() {
    const { amenityId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetAmenityByIdQuery(amenityId, { skip: !amenityId })
    const amenityData = data || {}

    return (
        <Container>
            <Row>
                <Col
                    xs={12}
                    lg={9}
                >
                    <h1>Amenity Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {amenityId && amenityData && amenityData._id && !isLoading && (
                        <AmenityEntry
                            amenityData={amenityData}
                            fullView={true}
                        />
                    )}
                </Col>

                <Col
                    xs={12}
                    lg={3}
                >
                    <DataLogList
                        dataType="amenity"
                        dataId={amenityId}
                    />
                </Col>
            </Row>
        </Container>
    )
}
